import BaseModel from './BaseModel';
export default class SupplierFAQs {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.answer = data.answer;
        this.id = data.id;
        this.question = data.question;
        this.languageCode = data.languageCode;
    }

    static parseDataFromResponse = (data = []) => {
        return data.map(e => new SupplierFAQs(e));
    }
}
